export default __webpack_public_path__ + "static/media/3-5.e30b52b3.png";